/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import toastr from '@/lib/notifications';
import $ from 'jquery';
import store from '../state/store'

store.on('lead:comments:index', function(lead_id) {
  const params =
    {lead_id};

  return $.ajax({
    url: "/api/sales/lead_comments",
    type: 'GET',
    dataType: 'json',
    contentType: 'application/json',
    data: params,
    success: (data) => {
      const lead = store.get().lead;

      // A message sent from a docked panel can be for a lead no longer on screen
      if (lead && String(lead.id) === String(lead_id)) {
        lead.set({comments: data.items});
      }
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

store.on('lead:comments:create', function(lead_id, comment_name) {
  const params = {
    lead_id,
    comment_name
  };

  return $.ajax({
    url: "/api/sales/lead_comments",
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(params),
    success: (data) => {
      return store.get().lead.comments.unshift(data);
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}